import React, { useContext, useEffect, useMemo, useState } from 'react';

import { Select, Tooltip } from 'antd';
import { useGetObserversQuery } from 'src/redux/services/centralApi';
import { FormItem, FormLabel } from 'src/pages/observers/components/styles';
import { ITagsSelectComponent } from 'src/pages/observers/components/TagsSelect/types';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { checkRole } from 'src/common/helpers/checkRole';
import { AuthContext } from 'src/AuthProvider';

export default function TagsSelect(
	{
		defaultTags,
		onTagsChange,
	}: ITagsSelectComponent
) {
	const { user, } = useContext(AuthContext);

	const {
		data: observersData,
		isLoading: isLoadingObservers,
	} = useGetObserversQuery();

	const [ selectedTags, setSelectedTags, ] = useState<string[]>(defaultTags ?? []);

	const isSuperUser = useMemo(() => {
		return checkRole('super_admin', { user, });
	}, [ user, ]);

	const tagsOptions = useMemo(() => {
		const filteredTags: string[] = [];
		const allTags = observersData?.flatMap((observer) => observer.tags);

		allTags?.forEach((tag) => {
			if (!filteredTags.includes(tag)) {
				filteredTags.push(tag);
			}
		});

		return filteredTags.map(el => (
			{ label: el, value: el, }
		));
	}, [ observersData, ]);

	useEffect(() => {
		onTagsChange && onTagsChange(selectedTags);
	}, [ selectedTags, ]);

	const filterOption = (input: string, option?: { label: string; value: string }) => (
		(option?.label ?? '')
			.toLocaleLowerCase()
			.normalize('NFD')
			.replace(/[\u0300-\u036f]/g, '')
			.includes(input.toLowerCase())
	);

	const handleTagsChange = (value: string[]) => {
		const fixedTags: string[] = [];

		value.forEach((tag) => {
			const fixedTag = tag
				.toLocaleLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '');

			if (fixedTags.includes(fixedTag)) return;

			fixedTags.push(fixedTag);
		});

		setSelectedTags(fixedTags);
	};

	return (
		<FormItem>
			<FormLabel>
				TAG(s):
				<Tooltip
					title={
						<>
							As tags são opcionais e são usadas apenas para a organização dos observadores.
							{
								isSuperUser && (
									<>
										<br />
										*Dica: O nome do módulo costuma ser uma boa tag.
									</>
								)
							}

						</>
					}
				>
					<QuestionCircleOutlined
						style={{
							color: 'rgba(0,0,0,0.45)',
							cursor: 'help',
						}}
					/>
				</Tooltip>
			</FormLabel>
			<Select
				mode='tags'
				placeholder='Tags'
				value={selectedTags}
				options={tagsOptions}
				onChange={handleTagsChange}
				filterOption={filterOption}
				loading={isLoadingObservers}
			/>
		</FormItem>
	);
}
